module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-double-up-50182485e8957930ece237f5893d9e63.svg";